import { render, staticRenderFns } from "./ApresentationComponent.vue?vue&type=template&id=6d62ed7c&scoped=true&"
import script from "./ApresentationComponent.vue?vue&type=script&lang=ts&"
export * from "./ApresentationComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ApresentationComponent.vue?vue&type=style&index=0&id=6d62ed7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d62ed7c",
  null
  
)

export default component.exports